import React, { useState, useEffect } from 'react';
import './SideMenu.css';
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Divider, IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MenuIcon from '@mui/icons-material/Menu';
import Logo from '../../assets/logo.png';
import InventoryIcon from '@mui/icons-material/Inventory';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { History, ReplayCircleFilledOutlined, ReplayCircleFilledRounded, Send } from '@mui/icons-material';
import SendTimeExtensionIcon from '@mui/icons-material/SendTimeExtension';
import AssessmentIcon from '@mui/icons-material/Assessment';

const SideMenuFornecedor = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [nomeUsuario, setNomeUsuario] = useState('');
  const [nomeFornecedor, setNomeFornecedor] = useState('');
  useEffect(() => {
    // Usuário
    let nomeUsuario = '';
    const user = localStorage.getItem('user');
    if (user) {
      try {
        nomeUsuario = JSON.parse(user).USU_NOME || '';
      } catch {
        nomeUsuario = user;
      }
    }
    setNomeUsuario(nomeUsuario);
  
    // Fornecedor
    let nomeFornecedor = '';
    const fornecedor = localStorage.getItem('nomeFornecedor');
    if (fornecedor) {
      try {
        nomeFornecedor = JSON.parse(fornecedor).FOR_RAZAO_SOCIAL || '';
      } catch {
        nomeFornecedor = fornecedor;
      }
    } else {
      // Caso esteja salva como string simples
      nomeFornecedor = localStorage.getItem('fornecedor') || '';
    }
    setNomeFornecedor(fornecedor);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('menuStateChange', {
      detail: { isCollapsed: isCollapsed }
    }));
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
    onClose();
  };

  const toggleCollapse = () => {
    if (isMobile) {
      onClose();
    } else {
      const newCollapsedState = !isCollapsed;
      setIsCollapsed(newCollapsedState);
      window.dispatchEvent(new CustomEvent('menuStateChange', {
        detail: { isCollapsed: newCollapsedState }
      }));
    }
  };

  const menuItems = [
    { text: 'Home', icon: <HomeIcon />, path: '/fornecedor/home' },
    { text: 'Cotacoes Enviadas', icon: <SendTimeExtensionIcon/>, path:'/fornecedor/cotacoesEnviadas'},
    { text: 'Historico', icon: <History />, path:'/fornecedor/historicoCompra'},
    { text: 'Relatorio', icon: <AssessmentIcon />, path:'/fornecedor/relatorio'}
  ];

  const shouldCollapse = !isMobile && isCollapsed;

  const handleNavigation = (path) => {
    if (shouldCollapse) {
      setIsCollapsed(false); // Expande o menu
    } else {
      navigate(path);
      if (isMobile && onClose) {
        onClose();
      } else {
        setIsCollapsed(true);
      }
    }
  };
  return (
    <Drawer
  anchor="left"
  open={isOpen}
  onClose={onClose}
  className={`side-menu ${shouldCollapse ? 'collapsed' : ''} ${isOpen ? 'open' : ''}`}
  variant={isMobile ? "temporary" : "permanent"}
  PaperProps={{
    sx: {
      width: shouldCollapse ? '64px' : '280px',
      transition: 'width 0.3s ease',
      overflowX: 'hidden'
    }
  }}
>
      <div className="menu-header">
        <div className="header-content">
          {!shouldCollapse && (
            <div className="user-info">
              <AccountCircleIcon className="user-icon" />
              <div className="user-details">
              <h3>{nomeUsuario || 'Usuário'}</h3>
              <span>{nomeFornecedor || 'Fornecedor'}</span>
              </div>
            </div>
          )}
          <IconButton
            onClick={toggleCollapse}
            className="menu-button"
            sx={{
              color: 'white',
              padding: '4px',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            {isMobile ? <ChevronLeftIcon /> : (shouldCollapse ? <MenuIcon /> : <ChevronLeftIcon />)}
          </IconButton>
        </div>
      </div>
      <Divider />
      <List className="menu-list">
        {menuItems.map((item) => (
          <Tooltip title={shouldCollapse ? item.text : ""} placement="right" key={item.text}>
            <ListItem
              button
              onClick={() => handleNavigation(item.path)}
              className="menu-item"
              sx={{
                justifyContent: shouldCollapse ? 'center' : 'flex-start',
                padding: shouldCollapse ? '12px 0' : '12px 16px'
              }}
            >
              <ListItemIcon className="menu-icon" sx={{ minWidth: shouldCollapse ? 0 : 40 }}>
                {item.icon}
              </ListItemIcon>
              {!shouldCollapse && <ListItemText primary={item.text} />}
            </ListItem>
          </Tooltip>
        ))}
      </List>
      <Divider />
      <div className="menu-footer">
        <Tooltip title={shouldCollapse ? "Sair" : ""} placement="right">
          <ListItem
            button
            onClick={handleLogout}
            className="logout-item"
            sx={{
              justifyContent: shouldCollapse ? 'center' : 'flex-start',
              padding: shouldCollapse ? '12px 0' : '12px 16px'
            }}
          >
            <ListItemIcon sx={{ minWidth: shouldCollapse ? 0 : 40 }}>
              <LogoutIcon />
            </ListItemIcon>
            {!shouldCollapse && <ListItemText primary="Sair" />}
          </ListItem>
        </Tooltip>
        <Divider />
        {!shouldCollapse && (
          <div className="footer-content">
            <img src={Logo} alt="Logo G2" className="footer-logo" />
            <p className="footer-text">Desenvolvido por G2</p>
          </div>
        )}
      </div>
    </Drawer>
  );
};

export default SideMenuFornecedor; 